import { SealCheck } from '@phosphor-icons/react';

const VerificationItem = ({ met, label, testId }) => (
  <div className="flex items-center gap-3" data-testid={testId}>
    <div className={`w-5 h-5 rounded-full flex items-center justify-center flex-shrink-0 ${
      met ? 'bg-primary text-white' : 'bg-surface_muted text-text_muted'
    }`}>
      {met ? <SealCheck size={12} weight="bold" /> : <span className="text-xs">-</span>}
    </div>
    <span className={`text-sm ${met ? 'text-text_main' : 'text-text_muted'}`}>{label}</span>
  </div>
);

/**
 * Verification tab: shows the trusted-seller requirements progress checklist.
 */
export const VerificationTab = ({ verification, t }) => {
  if (!verification) return null;
  return (
    <div className="bg-white border border-border rounded-2xl p-6" data-testid="verification-section">
      <h2 className="font-semibold font-heading mb-2 flex items-center gap-2">
        <SealCheck size={20} className={verification.is_verified ? 'text-primary' : 'text-text_muted'} />
        {t('pages.verification.title')}
      </h2>
      <p className="text-sm text-text_muted mb-4">{t('pages.verification.description')}</p>

      <div className="space-y-3">
        <VerificationItem
          met={verification.requirements.phone.met}
          label={t('pages.verification.reqPhone')}
          testId="verify-phone"
        />
        <VerificationItem
          met={verification.requirements.reviews.met}
          label={`${t('pages.verification.reqReviews')} (${verification.requirements.reviews.current}/5)`}
          testId="verify-reviews"
        />
        <VerificationItem
          met={verification.requirements.rating.met}
          label={`${t('pages.verification.reqRating')} (${verification.requirements.rating.current}/4.0)`}
          testId="verify-rating"
        />
      </div>

      <div className={`mt-4 p-3 rounded-lg text-sm font-medium ${
        verification.is_verified
          ? 'bg-primary/5 text-primary border border-primary/20'
          : 'bg-surface text-text_muted'
      }`} data-testid="verification-status">
        {verification.is_verified ? t('pages.verification.complete') : t('pages.verification.notYet')}
      </div>
    </div>
  );
};
